module.exports = __webpack_public_path__ + "img/bg-geo.5b17bd7.png";